// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","grey-light":"#c9c9c9","row":"_3tl7YMg","full_width_row":"_1rT-dBx _3tl7YMg","section_title":"_3P4V7J1 _1rT-dBx _3tl7YMg"};